module.exports = __webpack_public_path__ + "img/zh.87d6c351.svg";